module.exports = __webpack_public_path__ + "fonts/Inter-600-latin-ext44.fad2a54.woff2";